import * as Sentry from "@sentry/gatsby"

declare const __SENTRY_DSN__: string

if (__SENTRY_DSN__) {
  Sentry.init({
    dsn: __SENTRY_DSN__,
    sampleRate: 0.7,
    environment:
      process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development",
  })
}
